import { render } from "./DTButton.vue?vue&type=template&id=1928eb9c"
import script from "./DTButton.vue?vue&type=script&lang=js"
export * from "./DTButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__